// for saving user state
export const STOCKS_DETAILS_SELECT_TICKER = 'STOCK_DETAILS_SELECT_TICKER';
export const STOCKS_DETAILS_SELECT_VIEW_BY = 'STOCK_DETAILS_SELECT_VIEW_BY';
export const STOCKS_DETAILS_SELECT_DATE_BY = 'STOCK_DETAILS_SELECT_DATE_BY';
export const STOCKS_DETAILS_SELECT_CHART_TYPE = 'STOCK_DETAILS_SELECT_CHART_TYPE';
export const STOCKS_DETAILS_SELECT_CHART_BROKER = 'STOCK_DETAILS_SELECT_CHART_BROKER';

// for async data
export const IS_LOADING = 'STOCK_DETAILS_IS_LOADING';
export const STOCK_DETAILS_DATA = 'STOCK_DETAILS_DATA';
export const IS_ERROR = 'STOCK_DETAILS_IS_ERROR';
// for chart data
export const CHART_DATA = 'STOCK_DETAILS_CHART_DATA';

// for ticker data
export const STOCK_DETAILS_TICKER_DATA = 'STOCK_DETAILS_TICKER_DATA';
export const STOCK_DETAILS_RELOADED_TIME = 'STOCK_DETAILS_RELOADED_TIME';



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/StocksDetails/ActionTypes.ts